<template>
  <div>
    <ValidationObserver ref="form">
      <div class="md-layout">
        <component
            v-for="(field, index) in schema.fields"
            :key="index"
            class="md-layout-item"
            :is="mapper(field)"
            @on-update="updateForm"
            v-bind="field"
            :form-row="field"
            :objeto.sync="modelo"
        >
        </component>
      </div>
    </ValidationObserver>
  </div>
</template>

<script>
import SelectList from "./formElements/SelectList";
import TextInput from "./formElements/TextInput";
import DateInput from "./formElements/DateInput";
import ObjectInput from "./formElements/ObjectInput";
import CheckBox from "./formElements/CheckBox";

export default {
  name: "form_builder",
  components: {SelectList, TextInput, DateInput, ObjectInput, CheckBox},
  props: ["schema", "value", "fields", "model", "size"],
  data() {
    return {
      formData: this.value || {},
      modelo: this.model
    };
  },
  methods: {
    validate() {
      return this.$refs.form.validate().then(res => {
        this.$emit("on-validated", this.model);
        return res;
      });
    },
    updateForm(data) {
      this.$set(this.model, data.name, data.value);
      this.$emit("input", this.formData);
    },
    mapper(field) {
      if (field.type == "string" && field.attr.custom_type == "date") {
        return "DateInput";
      }
      if (field.type === "string") {
        return "TextInput";
      }
      if (field.type == "choice") {
        return "SelectList";
      }
      if (field.type == "boolean") {
        return "CheckBox";
      }
    }
  }
};
</script>
